import React from 'react';
import './proveedores.scss'

import marcasAberturas from '../../assets/img/proveedores/marcasAberturas.jpg';
import marcasElectricidad from '../../assets/img/proveedores/marcasElectricidad.jpg';
import marcasSanitarios from '../../assets/img/proveedores/marcasSanitarios.jpg';
import marcasConstruccion from '../../assets/img/proveedores/marcasConstruccion.jpg';
import marcasFerreteria from '../../assets/img/proveedores/marcasFerreteria.jpg';
import marcasAgua from '../../assets/img/proveedores/marcasAgua.png';
import rodados from '../../assets/img/proveedores/motomelbicicletas.png';

const Proveedores = () => {
	return (
		<>
			<section className="bgTitle bgProveedores py-10">
				<div className="container">
					<div className="row">
						<div className="col-sm-5">
							<h2>TRABAJAMOS CON LOS MEJORES</h2>
							<h3>NUESTROS PROVEEDORES</h3>
						</div>
					</div>
				</div>
			</section>

			<section>
				<div className="container">
					<div className="row">
						<div className="col-sm-4">
							<h2 className="big">Aberturas</h2>
							<ul className="list-unstyled color">
								<li><a target="_blank" href="http://www.valentinuz.com.ar/">Aberturas Valentinuz S.A.</a></li>
								<li><a target="_blank" href="https://mpotenza.com.ar/">Metalurgica Potenza</a></li>
								<li><a target="_blank" href="http://www.hermetal.com.ar">Aluminio Lermetal</a></li>
								<li><a target="_blank" href="https://www.nexo-aberturas.com.ar/">Nexo Aberturas</a></li>
							</ul>
						</div>
						<div className="col-sm-8 d-flex align-items-center">
							<img src={marcasAberturas} alt="" className="img-fluid"/>
						</div>
					</div>
				</div>
			</section>

			<section className="grey">
				<div className="container">
					<div className="row">
						<div className="col-sm-8 d-flex align-items-center">
							<img src={marcasConstruccion} alt="" className="img-fluid"/>
						</div>
						<div className="col-sm-4">
							<h2 className="big">Construcción</h2>
							<ul className="list-unstyled color">
								<li><a target="_blank" href="https://www.acindar.com.ar/">Acindar</a></li>
								<li><a target="_blank" href="http://www.cavellaneda.com.ar/">Cementos Avellaneda</a></li>
								<li><a target="_blank" href="https://cerronegro.com.ar/">Cerro Negro Cerámicas</a></li>
								<li><a target="_blank" href="http://www.cresata.com.ar">Cresata S.A.</a></li>
								<li><a target="_blank" href="https://www.cunmalleu.com.ar/">Cunmalleu</a></li>
								<li><a target="_blank" href="http://gruposursrl.com.ar/">Grupo Sur</a></li>
								{/* <li><a target="_blank" href="https://www.isolant.com.ar/">Isolant</a></li> */}
								<li><a target="_blank" href="http://www.kartonsec.com">Kartonsec</a></li>
								<li><a target="_blank" href="https://www.pcr.com.ar/">PCR</a></li>
								<li><a target="_blank" href="https://www.perfilesjma.com.ar/">Perfiles JMA</a></li>
								<li><a target="_blank" href="https://www.shap.com.ar/">SHAP</a></li>
								<li><a target="_blank" href="https://www.ar.weber/">Weber Saint-Gobain</a></li>
								{/* <li><a target="_blank" href="https://www.knauf.com.ar/">Knauf</a></li> */}
								<li><a target="_blank" href="https://www.durlock.com/">Durlock</a></li>
							</ul>
						</div>
					</div>
				</div>
			</section>

			<section>
				<div className="container">
					<div className="row">
						<div className="col-sm-4">
							<h2 className="big">Electricidad</h2>
							<ul className="list-unstyled color">
								<li><a target="_blank" href="http://www.gcfabricantes.com.ar/">GC Fabricantes</a></li>
								<li><a target="_blank" href="http://www.padilumsrl.com.ar">Padilum</a></li>
								<li><a target="_blank" href="https://www.roker.com.ar/">Roker</a></li>
								<li>Upercab S.A.</li>
							</ul>
						</div>
						<div className="col-sm-8 d-flex align-items-center">
							<img src={marcasElectricidad} alt="" className="img-fluid"/>
						</div>
					</div>
				</div>
			</section>

			<section className="grey">
				<div className="container">
					<div className="row">
						<div className="col-sm-8 d-flex align-items-center">
							<img src={marcasFerreteria} alt="" className="img-fluid"/>
						</div>
						<div className="col-sm-4">
							<h2 className="big">Ferretería</h2>
							<ul className="list-unstyled color">
								<li><a target="_blank" href="http://aliaforweb.com.ar/">Aliafor</a></li>
								<li><a target="_blank" href="https://www.balbico.com.ar">Balbico</a></li>
								<li><a target="_blank" href="https://btatools.com.ar">Bta tools</a></li>
								{/* <li><a target="_blank" href="https://www.bulonfer.com">Bulonfer</a></li> */}
								<li><a target="_blank" href="https://www.einhell.com.ar">Einhell</a></li>
								<li><a target="_blank" href="https://www.extrapowersa.com.ar/">Extra Power</a></li>
								<li><a target="_blank" href="https://gammaherramientas.com.ar/">Grupo Simpa</a></li>
								<li><a target="_blank" href="http://www.lijashunter.com.ar/">Hunter</a></li>
								{/* <li><a target="_blank" href="https://rcdistribuciones.com.ar">RC Distribuciones</a></li> */}
							</ul>
						</div>
					</div>
				</div>
			</section>

			<section className="last">
				<div className="container">
					<div className="row">
						<div className="col-sm-4">
							<h2 className="big">Griferías y Sanitarios</h2>
							<ul className="list-unstyled color">
								<li>Aceros ALFA</li>
								<li><a target="_blank" href="https://www.ferrum.com">Ferrum</a></li>
								<li><a target="_blank" href="https://gsudamericana.com.ar/">Grifería Sudamericana</a></li>
								<li><a target="_blank" href="http://www.homesistem.com.ar/">Homesistem S.A.</a></li>
								<li><a target="_blank" href="https://www.piazzagriferia.com/">Piazza</a></li>
								<li><a target="_blank" href="http://www.pringlessanluis.com.ar">Pringles San Luis</a></li>
								<li><a target="_blank" href="http://www.shawer.com/">Shawer Mamparas</a></li>
							</ul>
						</div>
						<div className="col-sm-8 d-flex align-items-center">
							<img src={marcasSanitarios} alt="" className="img-fluid"/>
						</div>
					</div>
				</div>
			</section>

			<section className="grey">
				<div className="container">
					<div className="row">
						<div className="col-sm-8 d-flex align-items-center">
							<img src={marcasAgua} alt="" className="img-fluid"/>
						</div>
						<div className="col-sm-4">
							<h2 className="big">Instalaciones de Agua, Gas y Cloacas</h2>
							<ul className="list-unstyled color">
								<li><a target="_blank" href="https://ips-arg.com/">IPS</a></li>
								<li><a target="_blank" href="http://grupodema.com.ar/productos/marcas/sigas/">SIGAS</a></li>
								<li>COES</li>
							</ul>
						</div>
					</div>
				</div>
			</section>


			<section className="last">
				<div className="container">
					<div className="row">
						<div className="col-sm-4">
							<h2 className="big">Rodados</h2>
							<ul className="list-unstyled color">
								<li><a target="_blank" href="https://motomelbicicletas.com.ar/">Bicicletas Motomel</a></li>
							</ul>
						</div>
						<div className="col-sm-8 d-flex align-items-center justify-content-center">
							<img src={rodados} alt="" className="img-fluid"/>
						</div>
					</div>
				</div>
			</section>

		</>
	);
}

export default Proveedores;